import { IconBaseProps } from 'react-icons';

import { LuClock, LuMail } from 'react-icons/lu';

const BADGE_CLOCK_STROKE_WIDTH = 8 / 3;

const stylesheet = {
  mail: '[mask-image:radial-gradient(circle_at_75%_62.5%,transparent_0.375em,black_0.375em)] [-webkit-mask-image:radial-gradient(circle_at_75%_62.5%,transparent_0.375em,black_0.375em)]',
  wrapper: 'relative inline-flex flex-shrink-0',
  badgeBackdrop:
    'absolute -right-[6.25%] bottom-[6.25%] flex h-[62.5%] w-[62.5%] items-center justify-center rounded-full',
  badgeIcon: 'h-full w-full text-semantic-text-primary',
};

export function ScheduledMailIcon({
  className,
  ...props
}: Readonly<IconBaseProps>) {
  return (
    <span className={stylesheet.wrapper}>
      <LuMail
        {...props}
        className={`${stylesheet.mail} ${className ?? ''}`.trim()}
      />
      <span className={stylesheet.badgeBackdrop} aria-hidden="true">
        <LuClock
          className={stylesheet.badgeIcon}
          strokeWidth={BADGE_CLOCK_STROKE_WIDTH}
        />
      </span>
    </span>
  );
}
